import React, { useState } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import qs from 'qs';
import Button from 'wonderbly-components/lib/Button';
import AvatarCard from 'wonderbly-components/lib/AvatarCard';
import AvatarCreationModal from '../../AvatarCreationModal';
import { useModel } from '../../../hooks';
import { replaceTextWithValues } from 'src/common/utils/text-replace';
import formatAdventurerName from 'src/common/utils/format-adventurer-name';
import './Avatars.scss';

const Avatars = (props) => {
  const { productAvatarCreation } = useModel();
  const drawer = props.drawer;
  const key = drawer.customisationKey;
  const allowedAvatars = Object.keys(productAvatarCreation.avatars).length;
  const values = get(props.productCustomisation, key) || [];
  const avatarsCount = values.length;

  const [ showAvatarCreation, setShowAvatarCreation ] = useState(null);
  const [ editIndex, setEditIndex ] = useState(null);

  const hideAvatarCreation = () => {
    setEditIndex(null);
    setShowAvatarCreation(false);
  };

  const onStartAgain = () => {
    setShowAvatarCreation(true);
  };

  const onEditCharacter = (idx) => () => {
    setEditIndex(idx);
    setShowAvatarCreation(true);
  };

  const onComplete = (data) => {
    let newValues = data;

    if (editIndex !== null) {
      const updated = data[editIndex];

      newValues = values.map((value, idx) => {
        if (idx === editIndex) {
          return updated;
        }
        return value;
      });
    }
    props.onFormikSubmit({ [key]: newValues }, props.activeDrawer);
    hideAvatarCreation();
  };

  const onCloseDrawer = () => {
    props.onToggleDrawer();
  };

  return (
    <div className="Avatars">
      {allowedAvatars > 1 && (
        <Button
          onClick={onStartAgain}
          outlined>
          {drawer.startAgainCta}
        </Button>
      )}
      <div className="Avatars__list">
        {values.map((value, idx) => {
          const avatarBaseUrl = productAvatarCreation.avatars[avatarsCount][idx].endpoint;
          const avatarImage = `${avatarBaseUrl}&${qs.stringify(value)}`;
          return (
            <AvatarCard
              key={idx}
              image={avatarImage}
              backgroundColor="#EFEEF5"
              title={replaceTextWithValues(drawer.characterTitle, value)}
              cta={drawer.editCharacterCta}
              onClick={onEditCharacter(idx)}
            />
          );
        })}
      </div>
      <Button
        onClick={onCloseDrawer}
        colour="green">
        {drawer.saveCta}
      </Button>
      <AvatarCreationModal
        className="Avatars__avatar-modal"
        isOpen={showAvatarCreation}
        data={productAvatarCreation}
        editData={{ index: editIndex, avatarsCount }}
        defaultValues={editIndex !== null ? values[editIndex] : null}
        onHandleClose={hideAvatarCreation}
        onHandleAllComplete={onComplete}
        onFormatNameField={data => formatAdventurerName(data)}
      />
    </div>
  );
};

Avatars.propTypes = {
  activeDrawer: PropTypes.string,
  productCustomisation: PropTypes.object.isRequired,
  drawer: PropTypes.shape({
    customisationKey: PropTypes.string.isRequired,
    startAgainCta: PropTypes.string.isRequired,
    characterTitle: PropTypes.string.isRequired,
    editCharacterCta: PropTypes.string.isRequired,
    saveCta: PropTypes.string.isRequired,
  }).isRequired,
  onFormikSubmit: PropTypes.func.isRequired,
  onToggleDrawer: PropTypes.func.isRequired,
};

export default Avatars;
